export default __webpack_public_path__ + "static/media/softlayer-horizontal.62ff7caf.svg";